import { dateFNS } from '@gogame/intl-ts';
import { ConfirmDialog } from '@gogame/components';
import { Typography } from '@gogame/components';
import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import CreateSAWithBigPeriodDialog from 'scenes/SpendAdjustments/components/SpendAdjustmentForm/CreateSAWithBigPeriodDialog';
import {
  createSpendAdjustment,
  checkSpendAdjustment,
} from 'scenes/SpendAdjustments/sources/spendAdjustment';

import { create, check } from '../queryKeyFactory';

export const useCheckSA = () => {
  const dummyCampaignConfirm = useScreenModalV2(ConfirmDialog);

  const checkMutation = useMutation(check(), checkSpendAdjustment);

  const handleCheck = async (values) => {
    const res = await checkMutation.mutateAsync(values);

    if (res.creationRequired) {
      return dummyCampaignConfirm({
        title: 'The selected affiliate is API integrated',
        confirmActionLabel: 'Add campaign',
        bodyText: (
          <>
            <Typography>
              Creating Spend Adjustments for such affiliates is not allowed.
            </Typography>{' '}
            <Typography>Create a "dummy" campaign instead</Typography>
          </>
        ),
      }).then(() => {
        return true;
      });
    } else {
      return false;
    }
  };

  return [handleCheck, checkMutation];
};

export const useCreateSA = () => {
  const showCreateSAWithBigPeriod = useScreenModalV2(
    CreateSAWithBigPeriodDialog
  );

  const createMutation = useMutation(create(), createSpendAdjustment, {
    onSuccess: async (response) => {
      const isPeriodMore4Month =
        response.dateFrom &&
        dateFNS.differenceInMonths(new Date(), response.dateFrom) >= 4;
      if (isPeriodMore4Month) {
        await showCreateSAWithBigPeriod();
      }
    },
    successMessage: () => {
      return 'Spend Adjustment created';
    },
  });

  const handleCreate = async (data) => {
    return createMutation.mutateAsync(data);
  };
  return [handleCreate, createMutation];
};
